import React from "react"
import { Link, useLocation } from "react-router-dom"
import withRouter from "../Common/withRouter"
import { withTranslation } from "react-i18next"
import { Info, Phone } from "lucide-react"

const SettingsSidebarContent = props => {
  const location = useLocation()

  return (
    <React.Fragment>
      <div id="sidebar-menu">
        <ul className="metismenu list-unstyled" id="side-menu">
          <li className="menu-title">{props.t("Settings")}</li>
          <li className={`${location.pathname === "/profile/settings" ? "mm-active" : ""}`}>
            <Link
              to="/profile/settings"
              className={`waves-effect ${location.pathname === "/profile/settings" ? "active" : ""}`}
            >
              <i className="uil-user-circle"></i>
              <span>{props.t("Profile")}</span>
            </Link>
          </li>
          <li className={`${location.pathname === "/profile" ? "mm-active" : ""}`}>
            <Link
              to="/profile"
              className={`waves-effect ${location.pathname === "/profile" ? "active" : ""}`}
            >
              <i className="uil-invoice"></i>
              <span>{props.t("Billings")}</span>
            </Link>
          </li>
          <li className={`${location.pathname === "/about-us" ? "mm-active" : ""}`}>
            <Link
              to="/about-us"
              className={`waves-effect ${location.pathname === "/about-us" ? "active" : ""}`}
            >
              <Info size={16} style={{ marginRight: 6 }} />
              <span>{props.t("About Us")}</span>
            </Link>
          </li>
          <li className={`${location.pathname === "/faq" ? "mm-active" : ""}`}>
            <Link
              to="/faq"
              className={`waves-effect ${location.pathname === "/faq" ? "active" : ""}`}
            >
              <i className="uil-question-circle"></i>
              <span>{props.t("FAQ")}</span>
            </Link>
          </li>
          <li className={`${location.pathname === "/support" ? "mm-active" : ""}`}>
            <Link
              to="/support"
              className={`waves-effect ${location.pathname === "/support" ? "active" : ""}`}
            >
              <i className="uil-life-ring"></i>
              <span>{props.t("Support")}</span>
            </Link>
          </li>
          <li className={`${location.pathname === "/contact-us" ? "mm-active" : ""}`}>
            <Link
              to="/contact-us"
              className={`waves-effect ${location.pathname === "/contact-us" ? "active" : ""}`}
            >
              <Phone size={16} style={{ marginRight: 6 }} />
              <span>{props.t("Contact Us")}</span>
            </Link>
          </li>
        </ul>
      </div>
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(SettingsSidebarContent))
